import React, { Suspense } from 'react';
import { EnhancedErrorBoundary } from '../errors/EnhancedErrorBoundary';
import { LoadingFallback } from './LoadingFallback';

interface AsyncBoundaryProps {
  children: React.ReactNode;
  componentName?: string;
  loadingMessage?: string;
  fallback?: React.ReactNode;
  onError?: (error: Error, componentStack: string) => void;
}

export function AsyncBoundary({
  children,
  componentName,
  loadingMessage,
  fallback,
  onError
}: AsyncBoundaryProps) {
  return (
    <EnhancedErrorBoundary
      componentName={componentName}
      fallback={fallback}
      onError={onError}
    >
      <Suspense fallback={<LoadingFallback message={loadingMessage} />}>
        {children}
      </Suspense>
    </EnhancedErrorBoundary>
  );
}
